<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_toc_1"><span>Praise for Asprin </span></p>
<p class="P_WFP_Quote">“Plenty of odd characters … fun!”</p>
<p class="P_WFP_QuoteByLine">–<i>Locus</i></p>
<p class="P_WFP_Quote">“A winning story … part science fiction, part spoof, part heart-warmer.”</p>
<p class="P_WFP_QuoteByLine">–<i>Publisher’s Weekly</i></p>
<p class="P_WFP_Quote">“Light without being frivolous, and displays Asprin’s considerable expertise about fencing and things military, especially leadership.”</p>
<p class="P_WFP_QuoteByLine">–<i>Chicago Sun-Times</i></p>
<p class="P_WFP_Quote">“Reminiscent of <span class="C_DefaultParagraphFont__And__No_Italic">M*A*S*H.”</span></p>
<p class="P_WFP_QuoteByLine">–<i>Analog</i></p>
<p class="P_WFP_Quote">“A grand mix of common sense, outrageous and hilarious foolishness stirred with a dash of wisdom into a delectable mess to be served with tongue in cheek.”</p>
<p class="P_WFP_QuoteByLine">–<i>Kliatt</i></p>
<p class="P_WFP_Quote">“Reliably entertaining … a fun read, light without being vapid and clever without being heavy-handed. This series is Asprin’s strongest to date, and it’s off to a good start.”</p>
<p class="P_WFP_QuoteByLine">–<i>Amazing</i></p>
<p class="P_WFP_Quote">“Asprin knows how to make me laugh … I suggest you sign up for this particular grand tour of duty.”</p>
<p class="P_WFP_QuoteByLine">–<i>Fear</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?22f2052f